import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJavascriptDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 58,
	height: 59,
	viewBox: "0 0 58 59",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.74219 5.00601H52.7422V53.006H4.74219V5.00601ZM41.4347 45.2452C39.2099 45.2452 37.952 44.0848 36.9852 42.5061L33.3196 44.6356C34.6438 47.252 37.3501 49.2482 41.5391 49.2482C45.8233 49.2482 49.0134 47.0235 49.0134 42.9625C49.0134 39.1956 46.8495 37.5202 43.0172 35.8768L41.8895 35.3937C39.9543 34.5556 39.1162 34.0078 39.1162 32.6547C39.1162 31.5598 39.9535 30.7217 41.2747 30.7217C42.5699 30.7217 43.4042 31.268 44.1775 32.6547L47.6899 30.3995C46.2042 27.7861 44.1425 26.788 41.2747 26.788C37.2465 26.788 34.669 29.3633 34.669 32.7461C34.669 36.4185 36.8313 38.1556 40.0861 39.5423L41.2137 40.0261C43.2709 40.9259 44.4975 41.4737 44.4975 43.0204C44.4975 44.3111 43.3036 45.2452 41.4347 45.2452ZM23.9543 45.217C22.4046 45.217 21.76 44.1541 21.0514 42.897L17.3798 45.1198C18.4434 47.3709 20.5349 49.2398 24.1463 49.2398C28.1433 49.2398 30.8815 47.1141 30.8815 42.4436V27.0455H26.3711V42.3827C26.3711 44.6372 25.4362 45.217 23.9543 45.217Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgJavascriptDark);
export { ForwardRef as ReactComponent };
